import { Checkbox as PCheckbox } from "primereact/checkbox";
import PropTypes from "prop-types";
import Label from "./Label";

const Checkbox = ({ input, label, disabled = false }) => {
  const { checked, onChange } = input;
  return (
    <div
      className={`edexlms-checkbox-container flex align-items-center gap-2 ${
        checked ? "checked" : "unchecked"
      }`}
      onClick={() => (!disabled && onChange(!checked)) || null}
      style={{ cursor: "pointer" }}
    >
      <PCheckbox
        inputId={`checkbox-${input.name}`}
        checked={checked}
        onChange={(e) => (!disabled && onChange(!checked)) || null}
      />
      {(label && (
        <Label label={label} disabled={disabled} htmlFor={input.name} />
      )) ||
        null}
    </div>
  );
};

Checkbox.propTypes = {
  disabled: PropTypes.bool,
  input: PropTypes.object,
  meta: PropTypes.object,
};

export default Checkbox;
